import React from 'react';
import clsx from 'clsx';
import InfoIcon from '@/shared/icons/InfoIcon';
import IconWrapper from '@/shared/components/UI/IconWrapper';

const InfoBanner = ({ 
  label, 
  variant = 'info',
  className = '',
  ...props 
}) => {
  const variantStyles = {
    info: 'rounded-v3-xs bg-v3-card-border',
  };

  return (
    <div
      className={clsx(
        'flex p-v3-xs flex-col justify-center items-start gap-v3-xs w-full',
        variantStyles[variant],
        className
      )}
      {...props}
    >
      <div className="flex items-center gap-v3-xs">
        <IconWrapper size={20}>
          <InfoIcon className="text-v3-black-secondary" />
        </IconWrapper>
        <p className="text-v3-h11 font-medium font-inter-variable text-v3-black-secondary">
          {label}
        </p>
      </div>
    </div>
  );
};

export default InfoBanner;
